const ga4 = {
  trackEvnt(category, parameters = null) {
    let trackingMode = $('body').data('tracking-mode')
    let trackingContainer = (trackingMode == 'production') ? 'G-CWN54EZKSC' : 'G-CQHD62GQJ0'
    const params = {
      send_to: trackingContainer,
      ...parameters
    }
    gtag('event', category, params)
  },
}
export default ga4
